<template>
    <Dialog :modal="true" v-model:visible="reject_pop"
        :header="t('assetManagement.Disposal.Popuplabel.RejectionReason')" @after-hide="IsClear"
        :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '50vw' }">
        <b-container fuild class="disposal_asset_details">
            <b-row>
                <b-col lg="6" class="field">
                    <div>
                        <p>{{ t('assetManagement.Disposal.Asset Name') }}:{{ propsdatas.AssetName }}</p>
                    </div>
                </b-col>
                <b-col lg="6" class="field">
                    <div>
                        <p>{{ t('assetManagement.Disposal.FlaggedDate') }}:{{ propsdatas.FlaggedDate }}</p>
                    </div>
                </b-col>
            </b-row>
            <b-row class="mb-3">
                <b-col lg="6" class="field">
                    <div>
                        <p>{{ t('assetManagement.Disposal.ReasonforDisposal.ReasonDisposal') }}:{{
                            propsdatas.ReasonForDisposal }}</p>
                    </div>
                </b-col>
                <b-col lg="6" class="field">
                    <div>
                        <p>{{ t('assetManagement.Disposal.Proposedmethod') }}:{{ propsdatas.DisposalMethodName }}</p>
                    </div>
                </b-col>
            </b-row>
            <!-- <b-row>
                <b-col lg="6" class="field">
                    <div>
                        <p>Expected Proceeds:{{ propsdatas.ExpectedProceeds}}</p>
                    </div>
                </b-col>
            </b-row> -->
            <b-row class="mb-4">
                <b-col lg="5">
                    <div class="field">
                        <TextArea :label="t('assetManagement.Disposal.Popuplabel.RejectionReason')"
                            :name="t('assetManagement.Disposal.Popuplabel.RejectionReason')"
                            v-model="updateApproval.rejectionReason" :rows="3" :rules="{ required: true }"
                            :required-icon="true" />
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <Footer @cancel="IsClear" :label="t('assetManagement.Disposal.Btn.Reject')" @save="reject" />
            </b-row>
        </b-container>
    </Dialog>
    <CreateSuccessully :visible="successpop" content="Rejected Successfully" @ok="closetrigger()" />
</template>
<script lang="ts">
import { defineComponent ,ref} from 'vue'
import TextArea from '../../../../../../../components/FormComponents/TextArea.vue';
import Footer from '../../../../../../../components/FormComponents/Footer.vue';
import { useI18n } from 'vue-i18n';
import {DisposalApprovalModels} from '../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/model/Disposal/disposalModel'
import DisposalService from '../../../../../../../modules/Inventory/Service/AssetManagement/DisposalService';
import CreateSuccessully from "../../../../../../../components/FormComponents/createdsuccessfully.vue";
export default defineComponent({
    components:{
        TextArea,
        Footer,
        CreateSuccessully
    },
    props:{
      reject_pop:{
        type:Boolean,
        default:false,
       },
        datas:{
        type:Object,
        default:null,
       },
    },
    setup(props,{emit}) {
    const reject_pop=ref(props.reject_pop);
    const { t } = useI18n();
    const reject_reason=ref()
    const propsdatas=ref(props.datas)
    const successpop=ref(false)
    function IsClear(){
        reject_pop.value = false;
        emit('closepopup',reject_pop.value)
    }
    let usersData;
    let SessionUserData = localStorage.getItem("UsersData");
    if (SessionUserData !== null) {
        usersData = JSON.parse(SessionUserData);
    }
    const updateApproval=ref<DisposalApprovalModels>({
        id:propsdatas.value.Id,
        approvalStatus:"2",
        approvedBy:  usersData.UserId,
        rejectionReason: "",
        barcode: "",
        barcodeNumber: 0,
        status:"1"
    })
    async function reject(){
        try{
            let msg;
            updateApproval.value.approvedBy= updateApproval.value.approvedBy.toString()
            const data_response =  await DisposalService.updateapproval(updateApproval.value);
            msg = data_response["ErrorInfo"].ErrorCode;
            if (msg == null) {
                successpop.value = true;
            }
        }catch (error) {
            console.log (error);
        }
    }
    function closetrigger() {
        successpop.value = false;
        IsClear();
    }
    return{
        reject_pop,
        reject_reason,
        IsClear,
        t,
        reject,
        updateApproval,
        propsdatas,
        successpop,
        closetrigger
        
    }
    },
})
</script>
<style lang="scss" scoped>
.disposal_asset_details p {
    font-size: 14px;
    line-height: 18px;
    color: #000;
}
</style>

